import { useInnerBlocksProps, useBlockProps } from '@wordpress/block-editor';
import { useEffect, useState } from '@wordpress/element';
import { select, dispatch } from '@wordpress/data';

export default function Edit({ attributes, setAttributes, clientId }) {
  const { flexClass } = attributes;
  const blockProps = useBlockProps({});
  const { children, ...innerBlocksProps } = useInnerBlocksProps({
    className: `bf_layout ${flexClass}`,
  });

  return (
    <swiper-slide>
      <div {...blockProps}>
        <div {...innerBlocksProps}>{children}</div>
      </div>
    </swiper-slide>
  );
}
